<template>
  <div class="myAccount" v-if="!auth" @click.self="openModal">
    <a href="#login" class="myAccount-link grid-text" @click.self="openModal">{{$t('topbar.info.account')}}</a>
  </div>
  <div class="myAccount" v-else @click="hidden = !hidden" @mouseenter="hideNotMobile" @mouseleave="showNotMobile">
    <div class="myAccount-link grid-text">{{name}}</div>
    <transition name="append">
      <ul class="account-dropdown" v-if="!hidden">
        <router-link tag="li" :to="{name: 'profile'}">
          <span>{{$t('topbar.auth.profile')}}</span>
        </router-link>
        <li @click="logout">
          <span>{{$t('topbar.auth.logout')}}</span>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    name: 'account',
    data() {
      return {
        hidden: true,
      };
    },
    computed: mapState({
      auth: s => s.client.auth,
      name: s => `${s.client.client.firstName} ${s.client.client.lastName[0]}`,
    }),
    methods: {
      openModal() {
        this.$store.commit('loginModal/OPEN');
      },
      logout() {
        this.$store.dispatch('client/logout');
      },
      hideNotMobile() {
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (!isMobile) {
          this.hidden = false;
        }
      },
      showNotMobile() {
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (!isMobile) {
          this.hidden = true;
        }
      }
    },
  };
</script>

<style scoped>

  ul.account-dropdown {
    background: var(--black);
    position: absolute;
    z-index: 9;
    margin: 0 0 0 0;
    padding: 12px 0 10px 0;
    left: -70px;
    right: -70px;
    transition: all .4s ease;
  }

  ul.account-dropdown li {
    list-style: none;
    display: block;
    cursor: pointer;
    padding: 10px 30px 10px 30px;
  }

  ul.account-dropdown li span {
    color: #e6e8ec;
    transition: all .4s ease;
  }

  ul.account-dropdown li:hover span {
    color: var(--orange);
  }

  .append-enter-active, .append-leave-active {
    transition: opacity .5s;
  }

  .append-enter, .append-leave-to /* .append-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translateX(20px);
  }
</style>



// WEBPACK FOOTER //
// src/components/topbar/account.vue